<template>
    <!-- Page content -->
    <div class="container-fluid py-5 card-login"
         v-bind:style="{ backgroundImage: 'linear-gradient(to top, ' + $THEME ? ($THEME.primaryColor) : '#0b9dd1' + ', #ffffff)' }">
        <div class="row justify-content-center h-100 align-items-center">
            <div class="col-12 col-xl-5 col-lg-6 col-md-7 login-600">
                <div class="card bg-secondary shadow border-0">
                    <div class="card-header bg-transparent pb-5">
                        <img src="/img/brand/logo.png" className="logo"/>
                        <span class="small mb-0 align-bottom">V.{{ popVersion }}</span>
                    </div>
                    <BlockUI v-if="busy">
                        <div class="loader"></div>
                    </BlockUI>
                    <div class="card-body px-lg-5 py-lg-5">
                        <h3 class="text-muted pb-2">เข้าสู่ระบบ</h3>
                        <form @submit="handleSubmit" v-if="!checkParameterShippop">
                            <div class="form-group material-floater">
                                <input class="form-control" :class="{ 'is-invalid': submitted && $v.email.$error }"
                                       v-model="email" required/>
                                <label floater>E-Mail</label>

                                <!-- Vuelidate -->
                                <div v-if="submitted && $v.email.$error" class="invalid-feedback position-absolute">
                                    <span v-if="!$v.email.required">กรุณากรอกอีเมล์</span>
                                    <span v-if="!$v.email.email">รูปแบบอีเมล์ไม่ถูกต้อง</span>
                                </div>
                            </div>

                            <div class="form-group  material-floater">
                                <input class="form-control" :class="{ 'is-invalid': submitted && $v.password.$error }"
                                       placeholder="" type="password" autocomplete="on" v-model="password" required/>
                                <label floater>Password</label>
                                <div v-if="submitted && $v.password.$error" class="invalid-feedback position-absolute">
                                    <span v-if="!$v.password.required">กรุณากรอกรหัสผ่าน</span>
                                    <span v-if="!$v.password.minLength">กรุณากรอก"รหัสผ่าน"อย่างน้อย
                                        {{ $v.password.$params.minLength.min }} ตัวอักษร</span>
                                </div>
                            </div>

                            <div class="text-center">
                                <button type="submit" class="my-4 btn btn-info">Sign in</button>
                            </div>
                            <div class="container px-4 text-center text-muted">
                                <small v-if="$THEME.pdpa">เมื่อท่านลงชื่อเข้าใช้งาน หมายความว่าท่านได้รับทราบและยอมทำตาม
                                    <div v-if="pdpa.urlTermsOfUseShop">
                                        <a :href="pdpa.urlTermsOfUseShop" target="_blank">เงื่อนไขการใช้บริการ</a> &
                                        <a :href="pdpa.privacyPolicyShop" target="_blank">นโยบายความเป็นส่วนตัว</a>
                                    </div>
                                </small>
                            </div>
                        </form>
                        <div class="text-center" v-else>
                            <h3>ADMIN {{ $THEME.webTitle }}</h3>
                            <button type="button" class="m-4 px-5 btn btn-dark" v-if="checkParameterShippop"
                                    @click="loginWithAuth0()">
                                Sign in Auth0
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <ModalNotification :notiShop="noti"/>
    </div>
</template>

<script>
import validatePop from "../plugins/validatePop.js"
import ModalNotification from '@/components/custom/ModalNotification'
import setLocalStorage from '@/constants/LocalStorageManagement'
import {checkStatusShop} from "@/axios/noti.js";
import {getReportInvoice} from '@/axios/invoice'

import {
    required,
    email,
    minLength
} from "vuelidate/lib/validators";

const API_URL = process.env.VUE_APP_API;

import {getAgentInfo, login} from "@/api/login"
import {mapActions} from "vuex";

export default {
    name: "login",
    components: {
        ModalNotification
    },
    data() {
        return {
            popVersion: process.env.VUE_APP_VERSION,
            email: '123@gmail.com',
            password: '1Qaz2wsx#',
            submitted: false,
            busy: false,
            noti: {
                show: false,
                type: "",
                created_by: "",
                date_noti: "",
                due_date: "",
                router: true
            },
            userLogin: "",
            pdpa: this.$THEME.pdpa
        };
    },

    validations: {
        email: {
            required,
            email
        },
        password: {
            required,
            minLength: minLength(3)
        }
    },
    mounted() {
        const currentURL = window.location.href
        const httpPatt = /^http:\/\//ig
        if (httpPatt.test(currentURL) && !process.env.VUE_APP_HTTP) {
            window.location = currentURL.replace(httpPatt, 'https://')
        }
        const skipLeadPattern = /skiplead/ig
        if (process.env.VUE_APP_API_SHEET && !skipLeadPattern.test(currentURL)) // SET redirect to lead-sale
            this.$router.push("/lead-sale");
    },
    methods: {
        ...mapActions(["getUserInfo"]),
        handleRedirect() {
            const redirect = this.$route.query.redirect

            if (redirect) {
                this.$router.push(redirect);
            } else {
                this.$router.push("/");
            }
        },
        handleSubmit(e) {

            this.busy = true
            this.submitted = true;
            this.$v.$touch();
            if (this.$v.$invalid) {
                this.busy = false
                return false
            }
            e.preventDefault();
            if (this.password.length > 0) {
                login({
                    email: this.email,
                    password: this.password,
                    agentType: 0
                }).then(res => {
                    // eslint-disable-next-line no-console
                    console.log(res, 'aaaa')
                    let resLocalStorage = setLocalStorage.setLogin(res.data.data)
                    this.$WALLET = 0
                    this.noti.type = "NOTI_INVOICE"
                    this.noti.show = true
                    this.$store.commit('SET_TOKEN', res.data.token);
                    this.$store.commit('SET_LOGIN_USER', res.data.loginUser);
                    this.$store.dispatch('getUserInfo')
                    this.$router.push("/transports");
                }).finally(() => {
                    this.busy = false
                })
                // this.$http
                //     .post(API_URL + "/login", {
                //         email: this.email,
                //         password: this.password
                //     })
                //     .then(response => {
                //         // console.log( response )
                //         let checkError = validatePop(response)
                //         if (!checkError.status) {
                //             if (checkError.notices == "token is expired") {
                //                 this.$router.push("/logout")
                //             }
                //             this.busy = false
                //             this.showErrorModal(checkError.msg)
                //             return false
                //         }
                //         if (response.data.data) {
                //             let resLocalStorage = setLocalStorage.setLogin(response.data.data)
                //             this.$WALLET = response.data.data.wallet
                //             checkStatusShop().then(res => {
                //                 let status_shop = res.status_shop
                //                 let created_by = res.created_by
                //                 let payment_type = res.payment_type
                //                 setLocalStorage.createdBy().set(created_by)
                //                 if (['LOCK', 'LOCK_ACCOUNT'].includes(status_shop) || (status_shop == 'DEBT' && created_by != 'superadmin')) {
                //                     this.noti.created_by = created_by
                //                     this.noti.date_noti = res.date_noti
                //                     this.noti.due_date = (res.due_date) ? res.due_date : null
                //                     this.noti.type = status_shop
                //                     this.noti.show = true
                //                 } else if (resLocalStorage.user.role != "member" && (payment_type) && ['DAILY', 'WEEKLY', 'MONTHLY'].includes(payment_type)) {
                //                     getReportInvoice({
                //                         date: {
                //                             startDate: null,
                //                             endDate: null
                //                         },
                //                         status: 'UNPAID'
                //                     }).then(resInvoice => {
                //                         if (resInvoice.item.length > 0) {
                //                             this.noti.due_date = resInvoice.item[0].due_date
                //                             this.noti.type = "NOTI_INVOICE"
                //                             this.noti.show = true
                //                         } else {
                //                             this.handleRedirect();
                //                         }
                //                     })
                //                 } else {
                //                     if (
                //                         resLocalStorage.user.role === "superadmin" || resLocalStorage.user.role === "shippop"
                //                     ) {
                //                         // this.$router.push("/dashboardshippop");
                //                         this.$router.push("/transports");
                //                     } else if (resLocalStorage.user.role === "master") {
                //                         this.$router.push("/reportbrance");
                //                     } else {
                //                         this.handleRedirect();
                //                     }
                //                 }
                //                 this.busy = false
                //             })
                //         } else {
                //             if (response.data.error) {
                //                 this.busy = false
                //             }
                //         }
                //     }).catch(error => {
                //         this.busy = false
                //         // console.error(error.response);
                //         if (error.response.status >= 500) {
                //
                //             this.showErrorModal('โปรดรอสักครู่ ขณะนี้มีการปรับปรุงระบบ ขออภัยในความไม่สะดวก')
                //
                //         } else {
                //             this.showErrorModal('พบปัญหาการเชื่อมต่อ กรุณาติดต่อ...')
                //         }
                //
                //     })

            }
        },
        loginWithAuth0() {
            this.$auth0.loginWithRedirect();
        },
        showErrorModal(msgBody) {
            this.$bvModal.msgBoxOk(msgBody, {
                title: "ERROR",
                size: "sm",
                buttonSize: "sm",
                okVariant: "danger",
                okTitle: "ลองอีกครั้ง",
                contentClass: "modal-errors",
                headerClass: "p-2 border-bottom-0",
                footerClass: "p-2 border-top-0",
                centered: true
            });
        },
    },
    computed: {
        checkParameterShippop() {
            return this.$route.name === "adminlogin"
        },
    }
};
</script>

<style></style>
